module.exports = __webpack_public_path__ + "img/23412341.12f948b.png";